<app-share-button></app-share-button>
<div class="row">
    <div class="col-md-8 ScrollStyle-1">
        <div class="card crd p-3">
            <div class="row">
                <div class="col-md-10 col10 mt-2" (mouseover)="showpayment(true,'2')"
                    (mouseout)="showpayment(false,'2')" id="117">
                    <h2>Merchant Dashboard </h2>
                </div>
                <div class="col-md-2 col2 "><a href="javascript:void(0)" (click)="openShareOptions()"> <button
                            class="btn share"><img src="./assets/share (5).svg" style="width: 30px;"
                                (click)="menues('share-button')" alt=""> </button> </a>
                </div>
                <!-- <div class="col-md-12" (mouseover)="showpayment(true,'1')"
                    (mouseout)="showpayment(false,'1')" id='31'>
                    <div
                        style="max-width: 100%; overflow: hidden; padding-bottom: 56.25%; position: relative;">

                        <iframe
                            class="i-frame"
                            src="https://www.youtube.com/embed/RLUj" title="YouTube video player"
                            frameborder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                            allowfullscreen></iframe>
                    </div>
                </div> -->
                <div class="col-md-12 " (mouseover)="showpayment(true,'2')" (mouseout)="showpayment(false,'2')"
                    id="117">
                    <label for="" class="mt-3">A merchant dashboard is an online interface or platform provided by
                        payment gateway companies to merchants, allowing them to manage various aspects of their payment
                        processing activities. A merchant dashboard is a crucial tool for businesses engaged in online
                        or point-of-sale transactions. It serves as a centralized hub where merchants can monitor
                        transactions, view analytics, configure settings, and access tools to streamline their
                        payment-related operations. It streamlines the management of financial transactions, enhances
                        visibility into business performance, and provides merchants with the control they need to
                        optimize their payment processes.
                    </label>

                </div>
                <div class="col-md-12 mt-4" (mouseover)="showpayment(true,'3')" (mouseout)="showpayment(false,'3')"
                    id="118">
                    <h2>
                        Test Account Dashboard
                    </h2>
                    <label for="" class="mt-3">A test account in PayG is a simulated or sandbox environment that allows
                        developers and merchants to test the functionality of the payment gateway without processing
                        real transactions or money.
                    </label>

                    <ul>
                        <li class="mt-3">It's a way for developers to ensure that the integration with the payment
                            gateway works correctly and that transactions can be handled properly before deploying the
                            payment system in a live or production environment. </li>

                        <li class="mt-3">The test account dashboard will display the number of steps you have completed,
                            and to activate your account, you need to complete your KYC.</li>
                        <div class="col-md-12 mt-2">
                            <img src="./assets/md1.png" alt="" height="100%" width="100%">
                        </div>
                        <li class="mt-3">In a test account, merchants typically have access to a set of dummy features,
                            including payment links, pay buttons, invoices, Easy Collect, Smart Collect, and booking &
                            ticketing. This allows merchants to simulate and create payment links, pay buttons, and
                            profiles for Easy Collect and Smart Collect. While they can create these elements, they will
                            not be able to accept payments from customers. The purpose is to test the proper and smooth
                            functioning of these features, ensuring that their payment integration is robust and secure.
                        </li>
                        <div class="col-md-12 mt-2">
                            <img src="./assets/md2.png" alt="" height="100%" width="100%">
                        </div>
                        <li class="mt-3">The merchant test account also comes with comprehensive documentation to
                            facilitate learning about the products.
                        </li>
                    </ul>
                    <label for="" class="mt-2">Having a test account helps developers identify and fix any issues or
                        bugs in the payment processing flow before real transactions are involved, reducing the risk of
                        problems affecting actual customers. It's a common practice in the software development and
                        e-commerce industries to use test accounts during the development and testing phases of payment
                        gateway integration.
                    </label>


                </div>
                <div class="col-md-12 mt-3" (mouseover)="showpayment(true,'4')" (mouseout)="showpayment(false,'4')"
                    id="119">
                    <h2>Active Account </h2>
                    <label for="" class="mt-3">An "active account dashboard" in PayG refers to an online interface or
                        platform where merchants can manage and monitor their live or active payment processing
                        activities. This dashboard provides real-time information and tools for merchants to oversee and
                        control various aspects of their financial transactions.  </label>

                    <ul>
                        <li class="mt-3">Key features often include transaction history, analytics, reporting tools, and
                            settings for configuring payment options, account details, and security settings.
                        </li>

                        <li class="mt-3">Merchants can use the active account dashboard to track revenue, identify
                            successful transactions, and manage customer payment data securely.
                        </li>
                    </ul>

                </div>
                <div class="col-md-12 mt-3" (mouseover)="showpayment(true,'5')" (mouseout)="showpayment(false,'5')"
                    id="121">
                    <h2>Here are some common features found in an active account dashboard: </h2>
                    <label for="" class="mt-2">An "active account dashboard" in PayG refers to an online interface or
                        platform where merchants can manage and monitor their live or active payment processing
                        activities. This dashboard provides real-time information and tools for merchants to oversee and
                        control various aspects of their financial transactions.  </label>

                    <ul>
                        <li class="mt-3"><b>Transaction Overview: </b>&nbsp; Merchants can view a summary of recent
                            transactions, including successful payments, refunds, and chargebacks, allowing them to
                            monitor their financial activities at a glance. </li>

                        <li class="mt-3"><b>Analytics and Reporting: </b>&nbsp;The dashboard includes analytics tools
                            and reporting features that provide insights into sales performance, customer behavior, and
                            other relevant metrics. This data helps merchants make informed business decisions.

                        </li>

                        <li class="mt-3"><b>Settlement Reports: </b>&nbsp;Merchants can access details about financial
                            settlements, showing when funds from transactions will be transferred to their bank account.
                            This information helps in managing cash flow and financial planning.

                        </li>

                        <li class="mt-3"><b>Settings and Configuration: </b>&nbsp;Merchants can customize various
                            settings related to their accounts, such as branding, notifications, and other preferences,
                            giving them control over their payment processes.

                        </li>
                    </ul>
                    <label for="" class="mt-2"> In summary, an active account dashboard in a payment gateway company
                        provides merchants with the tools and information they need to actively manage and optimize
                        their live payment processing activities. It is a central hub for monitoring transactions,
                        analyzing performance, and configuring settings to meet specific business requirements.

                    </label>

                </div>

            </div>
        </div>
    </div>
    <div class="col-md-4 hide-tbl content2  ">
        <div class="card crd p-4">
            <div class="row">
                <div class="col-md-12">
                    <h5>
                        Table of Contents:
                    </h5>

                </div>

                <!-- <div class="col-md-12 mt-2">
                    <a href="#31"> <div class="row">
                        <div class="col-md-2"> <img src="./assets/video.svg" class="tab-icon intro"
                                alt=""> &nbsp;</div>
                        <div class="col-md-10"><span style="cursor: pointer;" class="videoHover"
                                [ngClass]="{'video':colors=='1'}" (click)="color('1')">
                                Introduction to Refunds </span>
                        </div>
                    </div></a>
                </div> -->
                <div class="col-md-12 mt-2">
                    <a href="#117">
                        <div class="row">
                            <div class="col-md-2"> <img src="./assets/edit.svg" class="tab-icon intro" alt="">
                                &nbsp;</div>
                            <div class="col-md-10"><span style="cursor: pointer;" class="textHover"
                                    [ngClass]="{'text':colors=='2'}" (click)="color('2')">
                                    Merchant Dashboard </span>

                            </div>

                        </div>
                    </a>
                </div>
                <div class="col-md-12 mt-2">
                    <a href="#118">
                        <div class="row">
                            <div class="col-md-2"> <img src="./assets/edit.svg" class="tab-icon intro" alt="">
                                &nbsp;</div>
                            <div class="col-md-10">
                                <span style="cursor: pointer;" class="textHover" [ngClass]="{'text':colors=='3'}"
                                    (click)="color('3')">
                                    Test Account Dashboard
                                </span>

                            </div>
                        </div>
                    </a>
                </div>
                <div class="col-md-12 mt-2">
                    <a href="#119">
                        <div class="row">
                            <div class="col-md-2"> <img src="./assets/edit.svg" class="tab-icon intro" alt="">
                                &nbsp;</div>
                            <div class="col-md-10">
                                <span style="cursor: pointer;" class="textHover" [ngClass]="{'text':colors=='4'}"
                                    (click)="color('4')">
                                    Active Account Dashboard </span>

                            </div>
                        </div>
                    </a>
                </div>
                <div class="col-md-12 mt-2">
                    <a href="#121">
                        <div class="row">
                            <div class="col-md-2"> <img src="./assets/edit.svg" class="tab-icon intro" alt="">
                                &nbsp;</div>
                            <div class="col-md-10">
                                <span style="cursor: pointer;" class="textHover" [ngClass]="{'text':colors=='5'}"
                                    (click)="color('5')">Features of Active Account </span>

                            </div>
                        </div>
                    </a>
                </div>


            </div>
        </div>
    </div>
    <div class="col-md-9 hide ft-9">
        <hr>
        <div class=" row crd">
            <div class="col-md-8">
                <a [routerLink]="['/onboarding']"> <button class="btn btn-color" (click)="menues('')"> <img
                            src="./assets/Arrow 3.svg" alt="">&nbsp;&nbsp;Onboarding Process

                    </button></a>

            </div>
            <div class="col-md-4    ">
                <a [routerLink]="['/e-agrement']">    <button class="btn btn-color" (click)="menues('')" >E-Aggrement 
                
                    &nbsp;<img src="./assets/Arrow 2 1.svg" alt=""></button>
               </a>
            </div>
        </div>
    </div>